import { useEffect, useState } from 'react';
import { Button, Form, InputProps, SaveButton, useGetOne } from 'react-admin';
import IconContentAdd from '@mui/icons-material/Add';
import IconCancel from '@mui/icons-material/Cancel';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { dataProvider } from '../../../firebase';
import { IHasWord, ISettings, ISpeaker } from '../../../types';
import { SETTINGS_UNIQUE_ENTRY_ID } from '../../settings';
import { SpeakersRaw } from './SpeakersRaw';
import { SpeakersResult } from './SpeakersResult';
import { ISpk, ParserAlgo } from './types';
import { getOrCreateSpeaker, getSpeakersFromInputText, TParserAlgo } from './utils';

interface ISpeakerParserDialogProps extends InputProps<any> {
  onChange: (spksId: string[]) => void;
}

export const SpeakerParserDialog = (props: ISpeakerParserDialogProps) => {
  const [showDialog, setShowDialog] = useState(false);
  const [parsedRawSpeakers, setParsedRawSpeakers] = useState<ISpk[]>([]);
  const settings = useGetOne<ISettings>('settings', { id: SETTINGS_UNIQUE_ENTRY_ID }).data;
  const [speakerRaw, setSpeakerRaw] = useState<string>('');

  const speakerSeparator = settings?.speakersAutoParser_speakerSeparator || '-';
  const nameSeparator = settings?.speakersAutoParser_nameSeparator || ' ';
  const removeWords = settings?.speakersAutoParser_remover.map((rw: IHasWord) => rw.word) || [];
  const parserAlgo: TParserAlgo = settings?.speakersAutoParser_algo || ParserAlgo.LASTNAME;

  useEffect(() => {
    if (!parserAlgo) return;
    const spks = getSpeakersFromInputText(speakerRaw, parserAlgo, speakerSeparator, removeWords, nameSeparator);
    setParsedRawSpeakers(spks);
  }, [settings, speakerRaw]); // eslint-disable react-hooks/exhaustive-deps

  const handleSubmit = async (values: unknown) => {
    console.log('---- handleSubmit', values);
    const allSpeakersData = await dataProvider.getList<ISpeaker>('speakers', {
      pagination: { page: 1, perPage: 50000000000 },
      sort: { field: 'isRockStar', order: 'ASC' },
      filter: undefined,
    });
    const selectedSpeakersProms = parsedRawSpeakers.map((s: ISpk) => {
      return getOrCreateSpeaker(allSpeakersData.data, s.name, s.lastName);
    });
    const selSpkIds: string[] = await Promise.all(selectedSpeakersProms);
    console.log('In uSpeakerParserDialog.handleSubmit(selSpkIds)', selSpkIds);
    props.onChange(selSpkIds);
    handleCloseClick();
  };

  const handleOpenClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setParsedRawSpeakers([]);
    setSpeakerRaw('');
    setShowDialog(false);
  };

  return (
    <>
      <Button onClick={handleOpenClick} label="Auto Parser">
        <IconContentAdd />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={handleCloseClick} aria-label="Create Speakers">
        <DialogTitle>Disertantes</DialogTitle>
        <Form resource={props.resource} onSubmit={handleSubmit}>
          <DialogContent>
            <SpeakersRaw onChange={setSpeakerRaw} />
            <SpeakersResult speakers={parsedRawSpeakers} />
          </DialogContent>
          <DialogActions>
            <Button label="ra.action.cancel" onClick={handleCloseClick}>
              <IconCancel />
            </Button>
            <SaveButton type="submit" alwaysEnable />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
};
